export default __webpack_public_path__ + "images/8358d4cdf5a72a26bfd230c7359c3b19-pageNotFound--dark@2x.png";